import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

import {
  NotificationElement,
  NotificationUserType,
} from '../../../models/dashboard.shared';

@Component({
  selector: 'app-announcement-toast',
  templateUrl: './announcement-toast.component.html',
  styleUrls: ['./announcement-toast.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          display: 'none',
          opacity: 0,
        })
      ),
      transition(
        'inactive => active',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 0,
            }),
            style({
              opacity: 1,
            }),
          ])
        )
      ),
      transition(
        'active => removed',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 1,
            }),
            style({
              transform: 'translate3d(10%, 0, 0) skewX(10deg)',
              opacity: 0,
            }),
          ])
        )
      ),
    ]),
  ],
})
export class AnnouncementToastComponent extends Toast {
  notificationUserTypeEnum = NotificationUserType;
  announcement: NotificationElement;
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage
  ) {
    super(toastrService, toastPackage);
  }

  action() {
    this.toastPackage.triggerAction();
    this.toastrService.clear(this.toastPackage.toastId);
    return false;
  }
}
